import { useTheme } from "styled-components";
import { stripHtmlTags } from "../../pages/SharedPages/ProductDetailPage/Activity/utils";
import {
  CardWrapper,
  ImageWrapper,
  PlaceholderImage,
  PlaceholderLogo,
  Body,
  ProductName,
  AttributesContainer,
  CardInfoBlock,
  MasterVariantBadge,
} from "../CardProduct/CardProduct";
import { useTranslation } from "react-i18next";
import { PIMProductMinimal } from "../../types/types.PIM";

export type HistoryProductCardData = {
  id: string;
  name: string;
  brand_name?: string | null;
  chemical_name?: string | null;
  cas_number?: string | null;
  product_description?: string | null;
  product_number?: string | null;
  cover_image?: string | null;
  image_url?: string | null;
  pim_product_type?: PIMProductMinimal["pim_product_type"];
};

export const HistoryProductCard = ({
  product,
}: {
  product: HistoryProductCardData;
}) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const name = product.name;
  const casNumber = product.cas_number || null;
  const chemicalName = product.chemical_name || null;
  const brandName = product.brand_name || null;
  const productNumber = product.product_number || null;
  const description = product.product_description
    ? stripHtmlTags(product.product_description)
    : "";
  const imageUrl = product.cover_image ?? product.image_url ?? null;
  return (
    <CardWrapper>
      <ImageWrapper>
        {imageUrl ? (
          <img src={imageUrl} alt={name || "Product"} />
        ) : (
          <PlaceholderImage>
            <PlaceholderLogo src={theme.portalLogoUrl} alt="Company Logo" />
          </PlaceholderImage>
        )}
        <MasterVariantBadge
          pim_product_type={(product.pim_product_type as any) ?? "standard"}
        />
      </ImageWrapper>
      <Body>
        {name && <ProductName>{name}</ProductName>}
        <AttributesContainer>
          {casNumber && (
            <CardInfoBlock
              header={t("CAS #")}
              content={casNumber}
              productId={product.id}
              fieldName="cas"
            />
          )}
          {chemicalName && (
            <CardInfoBlock
              header={t("Chemical Name")}
              content={chemicalName}
              productId={product.id}
              fieldName="chemical-name"
            />
          )}
          {brandName && (
            <CardInfoBlock
              header={t("Brand Name")}
              content={brandName}
              productId={product.id}
              fieldName="brand-name"
            />
          )}
          {productNumber && (
            <CardInfoBlock
              header={t("Product #")}
              content={productNumber}
              productId={product.id}
              fieldName="product-number"
            />
          )}
          {description && (
            <CardInfoBlock
              header={t("Description")}
              content={description}
              productId={product.id}
              fieldName="description"
              isDescription={true}
            />
          )}
        </AttributesContainer>
      </Body>
    </CardWrapper>
  );
};
